import React, { useState, useRef, useEffect } from "react";
import { FiLayout } from "react-icons/fi";
import "../styles/PresentationStyleSelector.css";

const STYLE_OPTIONS = [
  { value: "narrative", label: "Narrative", icon: "\uD83D\uDCD6" },
  { value: "bullet_points", label: "Bullet Points", icon: "\uD83D\uDCCB" },
  { value: "diagrams", label: "Diagrams", icon: "\uD83D\uDDFA\uFE0F" },
  { value: "real_world_examples", label: "Real-World Examples", icon: "\uD83C\uDF0D" },
];

const PresentationStyleSelector = ({
  selectedStyles,
  onStylesChange,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = (value) => {
    if (loading) return;
    const next = selectedStyles.includes(value)
      ? selectedStyles.filter((s) => s !== value)
      : [...selectedStyles, value];
    onStylesChange(next);
  };

  return (
    <div className="pss-container" ref={containerRef}>
      <button
        type="button"
        className={`pss-trigger${selectedStyles.length > 0 ? " pss-active" : ""}`}
        onClick={() => setIsOpen((v) => !v)}
        disabled={loading}
      >
        <FiLayout size={14} />
        <span className="pss-trigger-label">Answer Format</span>
        {selectedStyles.length > 0 && (
          <span className="pss-badge">{selectedStyles.length}</span>
        )}
        <span className="header-tooltip">
          Choose how answers are presented — bullets, diagrams, and more.
        </span>
      </button>

      {isOpen && (
        <div className="pss-popup">
          <div className="pss-popup-header">Presentation Style</div>
          {STYLE_OPTIONS.map((opt) => {
            const checked = selectedStyles.includes(opt.value);
            return (
              <label
                key={opt.value}
                className={`pss-option${checked ? " pss-option-checked" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => handleToggle(opt.value)}
                  disabled={loading}
                />
                <span className="pss-option-icon">{opt.icon}</span>
                <span className="pss-option-label">{opt.label}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PresentationStyleSelector;
